<template>
  <div class="resource-list">
    <div
      class="item"
      v-for="(item, index) in resourceList"
      :key="index"
      @click="lookOver(item)"
    >
      <img
        :src="
          require('../../../../assets/icon/' +
            resourceType(item.filePath) +
            '_icon.png')
        "
        alt=""
      />
      <div class="title">
        <span>{{ item.title }}</span>
        <span class="tag-box">{{ item.fileType ? item.fileType : "url" }}</span>
      </div>
      <!-- <div class="remark">
        {{
          (item.fileSize / 1024).toFixed(1) > 1024
            ? (item.fileSize / 1024 / 1024).toFixed(1) + "M"
            : (item.fileSize / 1024).toFixed(1) + "KB"
        }}
      </div> -->
    </div>
  </div>
</template>

<script>
import {
  transOnlineProjectCode,
  getOnlineCodeResource,
  onlineResourceId,
} from "../../../../api/mobileterminalread/index";
export default {
  data() {
    return {
      resourceList: [],
    };
  },

  created() {
    this.getResourceList();
  },

  methods: {
    // 获取资源列表
    getResourceList() {
      getOnlineCodeResource(this.$route.query.onlineCodeId).then((res) => {
        this.resourceList = res.data;
      });
    },

    // 查看资源详情
    lookOver(item) {
      if (item.filePath) {
        console.log(this.$route.query.isApp);
        if (this.$route.query.isApp !== undefined) {
          //来自app扫码
          onlineResourceId(
            item.id,
            this.$route.query.remoteAddr,
            this.$route.query.userAgent,
            this.$route.query.userName
          );
          if (this.$route.query.userName || item.isEncryption == "N") {
            //登录状态或者资源不是加密的，可以随意访问
            this.$router.push({
              path: "/app/read",
              query: {
                filePath: item.filePath,
                title: item.title,
                remark: item.remark,
              },
            });
          } else {
            //未登录且是加密资源
            alert("请先登录App");
          }
        } else {
          //如果不是来自app扫码，且是加密资源就不添加阅读记录提示下载app
          if (item.isEncryption == "N") {
            onlineResourceId(
              item.id,
              this.$route.query.remoteAddr,
              this.$route.query.userAgent,
              this.$route.query.userName
            );
          }

          this.$router.push({
            path: "/app/read",
            query: {
              filePath:
                item.isEncryption == "N" ? item.filePath : item.messageLink,
              title: item.isEncryption == "N" ? item.title : "",
              remark: item.isEncryption == "N" ? item.remark : "",
            },
          });
        }
      } else {
        alert("资源文件不存在");
      }
    },

    resourceType(link) {
      let suffix = link ? link.split("?")[0].substr(-3).toUpperCase() : "";
      let fileType = "";
      if (suffix == "MP3") {
        fileType = "audio";
      } else if (suffix == "MP4") {
        fileType = "video";
      } else if (suffix == "PDF") {
        fileType = "pdf";
      } else if (
        suffix == "PNG" ||
        suffix == "JPG" ||
        suffix == "PEG" ||
        suffix == "GIF"
      ) {
        fileType = "image";
      } else {
        fileType = "link";
      }
      return fileType;
    },
  },
};
</script>

<style scoped  lang='scss'>
div {
  box-sizing: border-box;
}
.resource-list {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px 15px;
  .item {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    width: 100%;
    height: 64px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    img {
      width: 48px;
      height: 48px;
    }
    .title {
      width: calc(100% - 48px);
      padding: 8px;
      font-size: 16px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      .tag-box {
        margin-top: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 50px;
        height: 18px;
        border-radius: 6px;
        background: #ffffff;
        opacity: 1;
        border: 1px solid #0081ce;
        font-size: 13px;
        font-family: PingFangSC-, PingFang SC;
        font-weight: normal;
        color: #0081ce;
      }
    }
    .remark {
      width: 64px;
      text-align: right;
      font-size: 14px;
      font-weight: 200;
      color: #999;
    }
  }
}
</style>